import { render, staticRenderFns } from "./user-workflow.vue?vue&type=template&id=0ffbafbf&scoped=true"
import script from "./user-workflow.vue?vue&type=script&lang=js"
export * from "./user-workflow.vue?vue&type=script&lang=js"
import style0 from "./user-workflow.vue?vue&type=style&index=0&id=0ffbafbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbafbf",
  null
  
)

export default component.exports